import { ControlGroup, Navbar, Tab, Tabs, Tag } from "@blueprintjs/core";
import * as React from "react";
import styled from "react-emotion";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { IState } from "../store";
import { HeaderProps } from "./Header.d";
import SignInDialog from "./SignIn";

const WheelContainer = styled("div")`
  margin-right: 20px;
`;

class Header extends React.Component<HeaderProps> {
  public render() {
    const {
      currentUser,
      linkPaths,
      location: { pathname },
    } = this.props;


    if(currentUser && currentUser.accountData.permissions.role === 'admin'){
      if(!currentUser.accountData.permissions.isDashboard){
        if(linkPaths.includes("dashboard")){
          linkPaths.shift();
        }
      }else{
        if(!linkPaths.includes("dashboard")){
          linkPaths.unshift("dashboard");
        }
      }
    }


    const username = currentUser
      ? currentUser.accountData
        ? currentUser.accountData.displayName ||
          currentUser.accountData.email ||
          currentUser.accountData.phoneNumber ||
          "hello, you"
        : null
      : null;

    console.log(pathname);
    console.log("userdata");
    console.log(currentUser?currentUser.accountData.permissions.role:111);

    let uName = username;
    if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(username)){

      if(currentUser && currentUser.accountData.permissions.ismask && currentUser.accountData.permissions.ismask === true){
        const prefix = username.substring(0, username .lastIndexOf("@"));
        uName = prefix + '@*******';
      }

    }

    if (
      pathname.includes("just-in") ||
      pathname.includes("table") ||
      pathname === "/wheel"
    ) {
      return "";
    }
    return (
      <Navbar fixedToTop={true} id="header_dm_block">
        <Navbar.Group align="left">
          <WheelContainer>
            <Link to="/">
              <img src="https://just-in.texnrewards.com/favicon.ico" />
            </Link>
          </WheelContainer>
          <Tabs
            defaultSelectedTabId={pathname.slice(1, pathname.length)}
            id="NavTabs"
            onChange={this.handleTabChange}
          >
            <Tab id="">
              <Tag minimal={true}>Home</Tag>
            </Tab>
            {linkPaths.map((path, index) => (
              <Tab
                id={path}
                key={index}
                title={path.charAt(0).toUpperCase() + path.slice(1)}
              />
            ))}
          </Tabs>
        </Navbar.Group>
        <Navbar.Group align="right">
          <ControlGroup>
            {username && (
              <Tag large={true} minimal={true}>
                {uName}
                {/* {username} */}
              </Tag>
            )}
            <SignInDialog />
          </ControlGroup>
        </Navbar.Group>
      </Navbar>
    );
  }

  private handleTabChange = (path: string) => {
    const { history } = this.props;

    history.push(`/${path}`);
  };
}

const mapStateToProps = ({ users: { currentUser } }: IState) => ({
  currentUser,
});

export default withRouter(connect(mapStateToProps)(Header));



// WEBPACK FOOTER //
// ./src/components/Header.tsx